export default {
    'Your Profile': 'Dein Profil',
    'My name is': 'Mein Name ist',
    'I\'m a': 'Ich bin',
    'Surname': 'Vorname',
    'Lastname': 'Nachname',
    'Create your': 'Erstelle dein',
    'new account': 'neues Konto',
    'Start': 'Start',
    'Continue': 'Weiter',
    'I\'m a': 'Ich bin ein/e',
    'Sex': 'Geschlecht',
    'Man': 'Mann',
    'Woman': 'Frau',
    'My age': 'Mein Alter',
    'Age': 'Alter',
    'years old': 'Jahre',
    'My height': 'Meine Grösse',
    'Height': 'Grösse',
    'My weight': 'Mein Gewicht',
    'Weight': 'Gewicht',
    'My body': 'Mein Body',
    'Body': 'Body',
    'Skinny': 'Skinny',
    'Average': 'Durchschnitt',
    'Corpulent': 'Korpulent',
    'Muscular': 'Muskulös',
    'BRSkinny': 'Skinny',
    'BRAverage': 'Durch- schnitt',
    'BRCorpulent': 'Korpu- lent',
    'BRMuscular': 'Musku- lös',
    'My goal': 'Mein Ziel',
    'Goal': 'Ziel',
    'Health': 'Gesundheit',
    'Endurance': 'Ausdauer',
    'Appearance': 'Aussehen',
    'Strength': 'Stärke',
    'BRHealth': 'Gesund- heit',
    'BREndurance': 'Aus- dauer',
    'BRAppearance': 'Aus- sehen',
    'BRStrength': 'Stärke',
    'Skip': 'Überspringen',
    'T&C': 'AGB',
    'Imprint': 'Impressum',
    'Help': 'Hilfe',
    'Deactivation': 'Abo-Verwaltung',
    'Profile': 'Profil',
    'Training': 'Training',
    'Eating plan': 'Ernährungsplan',
    'Statisitc': 'Statisitk',
    'Payment': 'Zahlung',
    'Settings': 'Einstellungen',
    'Save': 'Speichern',
    'Training Days': 'Trainingstage',
    'Days': 'Tage',
    'Streak': 'Streak',
    'Points': 'Punkte',
    'Finished Workouts': 'Abgeschlosene Übungen',
    'Workouts': 'Übungen',
    'O from M': '{O} von {M}',
    'Record': 'Bestleistung',
    'Complete training time': 'Komplette Trainingszeit',
    'W workouts with R repetitions': '{W} Workouts mit {R} Widerholungen',
    'workouts with': 'Workouts mit',
    'repetitions': 'Widerholungen',
    'S km stretch': 'Streckelauf von {S} km',
    'Take a break': 'Ruh dich aus',
    'Begin': 'Leg los',
    'Day': 'Tag',
    'Breakfast': 'Frühstück',
    'Dinner': 'Mittagessen',
    'Supper': 'Abendessen',
    'Duration': 'Dauer',
    'Repetitions with B sec break': 'Wiederholungen mit {B} sec Pause',
    'Difficulty': 'Schwierigkeit',
    'low': 'leicht',
    'middle': 'mittel',
    'high': 'hoch',
    'You made 1 Day': 'Du hast 1 Tag geschafft',
    'SUPER WORKOUT!': 'SUPER WORKOUT!',
    'With protein for training success': 'Mit Eiweiß zum Trainingserfolg',
    'Search': 'Suche',
    'Cancel': 'Beenden',
    'Snacks': 'Snacks',
    'Vegan': 'Vegan',
    'Lunch': 'Mittagessen',
    'Drink': 'Getränk',
    'Search terms': 'Suchbegriffe',
    'The transaction was successful. Thank you for using the service.': 'Die Transaktion war erfolgreich. Vielen Dank für die Nutzung des Dienstes.',
    'You will be redirected to the site in a moment. If this does not happen in a few seconds, click Next.': 'Sie werden in Kürze zur Website weitergeleitet. Wenn dies nicht in einigen Sekunden geschieht, klicken Sie auf Weiter.',
    'Pin could not be confirmed, please try again.': 'Pin konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.',
    'Ingredients': 'Zutaten',
    'Preparation': 'Vorbereitung',
    'Portions': 'Teile',
    'Contact': 'Kontakt',
    'DataProtection': 'Datenschutzerklärung',
    'Privacy': 'Nutzungsbedingungen',
    'Wrong Pin. Please check your SMS box.': 'Falsche Pin. Bitte überprüfen Sie Ihr SMS-Kästchen',
    'Wrong Pin. Please check your SMS box': 'Falsche Pin. Bitte überprüfen Sie Ihr SMS-Kästchen',
    'Write MSISDN to login': 'Schreiben Sie MSISDN, um sich anzumelden',
    'Easy': 'Leicht',
    'Normal': 'Normale',
    'Hard': 'Schwer',
    'More': 'Mehr',
    'See more workouts': 'Weitere Workouts anzeigen',
    'Workouts List': 'Trainingsliste',
    'Individual exercises': 'Einzelübungen',
    'Start training': 'Starte Training'
}


// WEBPACK FOOTER //
// ./src/i18n/at.js